import { Component, input } from '@angular/core';
import {
  OnyxDatePipe,
  OnyxIconComponent,
  OnyxInformationRowComponent,
} from '@onyx/angular';
import { ColorHelper } from '../../../helpers/color.helper';

@Component({
  selector: 'app-modal-date-row',
  imports: [OnyxInformationRowComponent, OnyxDatePipe, OnyxIconComponent],
  templateUrl: './modal-date-row.component.html',
  styleUrl: './modal-date-row.component.scss',
})
export class ModalDateRowComponent {
  public readonly label = input.required<string>();
  public readonly expirationDate = input.required<string>();
  public readonly size = input<120 | 184>(120);

  protected readonly ColorHelper = ColorHelper;
}
